import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DatiGeneraliConFondoRischiForm } from "../../../common/form/dati-generali-con-fondo-rischi-form";
import { ModalitaPartecipazione } from "../../../common/models/tipologiche/modalita-partecipazione";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { HelpersService } from "../../../core/services/helpers.service";
import { OperationsService } from "../../../core/services/operations.service";
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-mediazione',
  templateUrl: './form-mediazione.component.html',
  styleUrls: ['./form-mediazione.component.css']
})
export class FormMediazioneComponent extends DatiGeneraliConFondoRischiForm implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  tipiNatura: TipoNatura[] = [];
  modalitaPartecipazioni: ModalitaPartecipazione[] = [];
  idPratica: string;
  tipoFascicolo: string;
  tipoPratica: number;
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
    this.inizializzaFondoRischi(this.request.fascicolo.flagFondoRischi, this.request.fascicolo.dataVariazioneFondoRischi);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura, Validators.required],
      stato: [init ? null : this.request.fascicolo.stato],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      definito: [init ? null : this.request.fascicolo.definito],
      dataDefinizione: [init ? null : this.request.fascicolo.dataDefinizione],
      motivoDefinizione: [init ? null : this.request.fascicolo.motivoDefinizione],
      note: [init ? null : this.request.fascicolo.note],
      modalitaPartecipazione: [init ? null : this.request.fascicolo.modalitaPartecipazione],
      sedeIncontro: [init ? null : this.request.fascicolo.sedeIncontro, Validators.required],
      organismoMediazione: [init ? null : this.request.fascicolo.organismoMediazione, Validators.required],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      dataVariazioneFondoRischi: [init ? null : this.request.fascicolo.dataVariazioneFondoRischi],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
    });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  populateSelect() {
    this.helpers.getModalitaPartecipazioni().subscribe(response => this.modalitaPartecipazioni = response);
   }

   isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }

  save() {
    this.saveForm.emit();
  }
}
